import { Component, OnInit, Input} from '@angular/core';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { QuizData } from '../QuizData';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { routerNgProbeToken } from '@angular/router/src/router_module';
// import { userInfo } from 'os';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { CookieService } from 'ngx-cookie-service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../../alert-component';

@Component({
  selector: 'app-riskquiz',
  templateUrl: './riskquiz.component.html',
  styleUrls: ['./riskquiz.component.css']
})
export class RiskquizComponent implements OnInit {
  riskquizForm : FormGroup;
  submitted: boolean = false;
  // userId;
  
  successMessage: string;
  failedMessage: string;
  constructor(
    private route: ActivatedRoute,
    private cookie : CookieService,
    private router: Router,
    private  _bkoffService: BackOffServiceService,
    private formBuilder : FormBuilder,
    private modalService: NgbModal
    ) {
      Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
      (Parse as any).serverURL = environment.serverURL;
    }

  ngOnInit() {
    let regexPatterns = {
      // this can be improved
      age: "^[0-9]+$",
      weight: "^[0-9]+$",
      height: "^[0-9]+$"
   };
    this.riskquizForm  =  this.formBuilder.group({
  
      age: ['', [Validators.required, Validators.pattern(regexPatterns.age)]],
      weight: ['', [Validators.required, Validators.pattern(regexPatterns.weight)]],
      height: ['', [Validators.required, Validators.pattern(regexPatterns.height)]],
      gender: ['', Validators.required],
      family: ['', Validators.required],
      ethnicity: ['', Validators.required],
      bp: ['', Validators.required],
      active: ['', Validators.required],
      gestational: ['', Validators.required],
       
    });

    // this.route.paramMap.subscribe(params => {
    //   this.userId = params.get('userId');
    // });
    // console.log(this.userId);
  }

  get fmBuilder() { return this.riskquizForm.controls; }


  getFormControl(name:any) {
    return this.riskquizForm.get(name);
  }
  

  reset(){
    this.riskquizForm.reset({PersonalData: new QuizData()});
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.riskquizForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.riskquizForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  btnclick(){
    const result: QuizData = Object.assign({}, this.riskquizForm.value);
    let fromResult = Object.assign({}, result);

    this.submitted = true;

    console.log("about to check form validation");
    // stop here if form is invalid    
    if (this.riskquizForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
      return;
    }

     const signUpData = this.riskquizForm;
     
     
      var userInfo = new QuizData()
      userInfo.age = Number(signUpData.get(['age']).value)
      userInfo.weight = Number(signUpData.get(['weight']).value)
      userInfo.height = signUpData.get(['height']).value
      userInfo.gender = Number(signUpData.get(['gender']).value)
      userInfo.family = Number(signUpData.get(['family']).value)
      userInfo.ethnicity = Number(signUpData.get(['ethnicity']).value)
      userInfo.bp = Number(signUpData.get(['bp']).value)
      userInfo.active = Number(signUpData.get(['active']).value)
      userInfo.gestational = Number(signUpData.get(['gestational']).value)

      var score = 0
      let age = Number(userInfo.age)
      if(age>39 && age<50){score++}
      else if(age>49 && age<60){score+=2}
      else if(age>=60){score+=3}

      if (userInfo.gender==1){score++}
      if (userInfo.gestational==1){score++}
      if (userInfo.family==1){score++}
      if (userInfo.bp==1){score++}
      if (userInfo.active==2){score++}
      if (userInfo.ethnicity==1 || userInfo.ethnicity==2
      || userInfo.ethnicity==3){score++}
      let height = Number(userInfo.height)
      let weight = Number(userInfo.weight)
      var bmi = weight/(height)^2
      bmi *= 730
      if (bmi>=25 && bmi<30){score++}
      else if(bmi>=30 && bmi<40){score+=2}
      else if (bmi>=40){score+=3}
      
      userInfo.score = score
      console.log("score " + userInfo.score)

      this.cookie.set("riskScore", String(score));

      this._bkoffService.setQuizData(userInfo);

      console.log("btnclick registered")
      this.router.navigateByUrl('/quiz2');
  };

}
